import { Node } from '@tiptap/core';

const Text = Node.create({
    name: 'text',
    group: 'inline',
});

export { Text, Text as default };
//# sourceMappingURL=index.js.map
